
import debounce from "lodash/debounce"
import breadcrumb from "../library/breadcrumb.vue"
import { getDshopData } from "../api/gateway"
import commonConfig from "@/utils/common"
import getCartNumMixin from "@/mixins/getCartNum"
import { getHeadLink, getHeadMeta } from "@/utils/head"
import {
  getRequestHeaders,
  parseJSON,
  appendUrlParams,
  formatProductParamsBy,
  redirectToLoginPage
} from "@/utils/utils"
import Storage from "@/utils/storage"
import { Logger } from "@/plugins/logger"
import { trackShareCampaignClick } from "@/utils/track/share"
/**
 * 获取URL参数
 */
const getURLParams = ({ query, params }, $cookies) => {
  const { id, urlPath } = Object.assign(query, params)
  const urlParms = formatProductParamsBy({ urlPath: id || urlPath }, $cookies)
  return urlParms
}

export default {
  components: {
    breadcrumb
  },
  mixins: [getCartNumMixin],
  validate({ query, params }) {
    return query.urlPath || params.id
  },
  async asyncData({ route, req, error, store, redirect, app, $cookies }) {
    try {
      const { data } = await getDshopData(
        {
          param: getURLParams(route, $cookies),
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )
      const inspect = data.inspect === "null" ? null : parseJSON(data.inspect)
      const pageData = Object.freeze(JSON.parse(data.renderData))
      const pageStore = parseJSON(data.renderStore)
      const lang = store.state.lang
      const fullPath = route.fullPath
      if (inspect && inspect.code === "1003" && inspect?.model?.redirectUrl) {
        if (process.server) {
          redirect(inspect.model.redirectUrl)
        } else {
          window.location.href = inspect.model.redirectUrl
        }
        return
      }
      return {
        inspect,
        pageData,
        pageStore,
        pageTitle: data?.titleF?.replace(/^\$/, ""),
        pageName: pageData?.settings?.pageName,
        lang: lang == "en_US" ? "en" : "zh-hant",
        fullPath
      }
    } catch (err) {
      Logger.error("dshop初始化报错", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      breadcrumbData: [],
      lang: "",
      fullPath: "",
      enableZoom: false
    }
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        { hid: "description", name: "description", content: this.pageTitle },
        { name: "og:type", content: "website" },
        { name: "og:title", content: this.pageTitle },
        { name: "og:description", content: this.pageTitle },
        ...getHeadMeta(this)
      ],
      link: getHeadLink(this)
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if (this.panzoomInstance) {
      this.panzoomInstance.destroy()
      window.removeEventListener("keydown", this.handleZoomKeys)
    }
  },
  methods: {
    init() {
      this.initBreadcrumb()
      this.enableZoom = !!this.$route.query.zoom
      if (this.enableZoom) {
        // 动态加载 panzoom
        import("@panzoom/panzoom")
          .then(panzoomModule => {
            this.panzoomInstance = panzoomModule.default(this.$refs.zoomContainer, {
              maxScale: 5,
              minScale: 1,
              bounds: true,
              boundsPadding: 0.1
            })
          })
          .catch(error => {
            console.error("Failed to load Panzoom:", error)
          })
        window.addEventListener("keydown", this.handleZoomKeys)
      }
    },
    initBreadcrumb() {
      const whereFrom = {
        name: this.$t("common.home"),
        path: this.MAIN_ORIGIN_HOME
      }
      const selPath = this.pageName ? [{ name: this.pageName }] : []

      this.breadcrumbData = [whereFrom, ...selPath]
    },
    handleCopyUrl: debounce(function () {
      const { custId } = Storage.get("accountInfo", { useBase64: true }) || {}
      trackShareCampaignClick({
        campaignName: this.pageName,
        campaignId: this.pageStore.pageId,
        userId: custId
      })
      const { isOnline } = this.$utils.getLoginStatus()
      if (!isOnline) {
        redirectToLoginPage()
        return
      }
      const { commonReqParams } = this.$commonParams
      const urlParams = {
        utm_source: "Share",
        utm_medium: "7EHK_web",
        utm_campaign: "dshop",
        u: custId || "",
        storeId: commonReqParams.storeId,
        venderId: commonReqParams.venderId,
        storeType: 1,
        needJumpHome: 1
      }
      const url = appendUrlParams(window.location.href, urlParams)
      this.$copyText(url).then(res => {
        this.$message({ message: this.$t("common.shareWithCopyText"), type: "success", duration: 1000 })
      })
    }, 500),
    handleZoomKeys(event) {
      if (!this.panzoomInstance) return

      // 同时支持 Ctrl（Windows）和 Meta（Mac）的缩放操作
      if (event.ctrlKey || event.metaKey) {
        if (event.key === "=" || event.key === "+") {
          event.preventDefault()
          this.panzoomInstance.zoomIn()
        } else if (event.key === "-") {
          event.preventDefault()
          this.panzoomInstance.zoomOut()
        }
      }
    }
  }
}
